import React, { useState, useContext } from 'react';
import '../../css/card.css';
import { functionContext } from '../../App';

function Card({id, english, german, luckyCard}) {

  const { setSelectedWord, setSelectedLanguage } = useContext(functionContext);
  // console.log("Card rerendering ==>>>")
  // console.log(id)

  // console.log(cardIdArray)

// console.log(`Card component lucky card: ${luckyCard}`)

// let luckyCardToHide = document.getElementsByClassName(`card_${id}`)
// console.log(luckyCardToHide)

  const [displayedWord, setdisplayedWord] = useState(true);

function changeState(e) {
    const nextShown = !displayedWord;
    setdisplayedWord(nextShown);
    if (nextShown) {
      setSelectedWord(german);
      setSelectedLanguage('de');
    } else {
      setSelectedWord(english);
      setSelectedLanguage('en');
    }
    handleClick(e)
  }

  const handleClick = event => {
    // 👇️ toggle styles on click
    if (event.currentTarget.style.backgroundColor) {
      event.currentTarget.style.backgroundColor = null;
      event.currentTarget.style.color = null;
    } else {
      event.currentTarget.style.backgroundColor = '#BE8A60';
      event.currentTarget.style.color = 'white';
    }

    // 👇️ toggle class on click
    // event.currentTarget.classList.toggle('my-class-1', 'my-class-2');
  };

  return (
    <>
      {/* {displayedWord && german} */}
      <div id="card" className={`card_${id}`} onClick={(e) => changeState(e)}>{displayedWord ? english : german}</div>
     
    </>
  )
}

export default Card;
